// TODO: credit https://github.com/lezer-parser/markdown/blob/main/src/markdown.ts
import { EditorState } from "@codemirror/state";
import { ensureSyntaxTree } from "@codemirror/language";
import { PartialTabParse } from "@tab-edit/model";
import { NodeBlueprint } from "./nodes/generator/blueprint";
import { TabAST } from "../structures/tree";
import { ASTFragment } from "../structures/fragment";

// TODO: Think of a better name for this class
export class PartialASTParse extends PartialTabParse<ASTFragment> {
    parsedPos: number;

    /// @internal
    constructor(
        private editorState: EditorState,
        private cachedFragments: readonly ASTFragment[],
        readonly ranges: readonly {from: number, to: number}[],
        private blueprint: NodeBlueprint
    ) {
        super();
        this.parsedPos = ranges[0]?.from || 0;
    }

    advance(catchupTimeout = 500, catchupDistance = 2000): {blocked:boolean, tree: TabAST|null} {
        if (this.fragments.length!==0 && !this.fragments[this.fragments.length-1].isParsed) {
            this.fragments[this.fragments.length-1].advance();
            return {blocked: false, tree: null};
        }
        if (this.stoppedAt !== null && this.parsedPos > this.stoppedAt)
            return {blocked: false, tree: this.finish()};
            
        if (this.parsedPos >= this.editorState.doc.length)
            return {blocked: false, tree: this.finish()};

        let syntaxTree = ensureSyntaxTree(this.editorState, this.parsedPos+catchupDistance, catchupTimeout);
        if (!syntaxTree) return {blocked: true, tree: null}
         
        let current = syntaxTree.topNode.childAfter(this.parsedPos) || syntaxTree.topNode;
 
        // TODO: maybe handle case here where we may not want to reuse fragment because the fragment has been changed from what it actually is (maybe the rawparsetree didn't parse teh full tabsegment last time so we want to replace it with newly, fully parsed tab segment)
        if (this.cachedFragments && this.reuseFragment(current.from))
            return {blocked: false, tree: null}
        
        if (this.fragments.length!=0 && this.fragments[this.fragments.length-1].from==current.from && this.fragments[this.fragments.length-1].to < current.to) {
            // previous fragment was formed from an incompletely-parsed syntax node
            this.fragments.pop()
        }

        let frag = ASTFragment.startParse(current, this.editorState, this.blueprint);
        if (frag) {
            this.fragments.push(frag);
            this.parsedPos = current.to;
            return {blocked: false, tree: null};
        }

        let skipTo = (current.from==current.to) ? current.to+1 : current.to; // for zero-width error nodes, prevent being stuck in loop.
        let prevFrag = this.fragments[this.fragments.length-1];
        let blankFrag: ASTFragment;
        if (prevFrag && prevFrag.isBlankFragment) {
            // combine consecutive blank fragments into one.
            blankFrag = ASTFragment.createBlankFragment(prevFrag.from, skipTo);;
            this.fragments[this.fragments.length-1] = blankFrag;
        } else {
            blankFrag = ASTFragment.createBlankFragment(this.parsedPos, skipTo);
            this.fragments.push(blankFrag);
        }
        this.parsedPos = skipTo;
        return {blocked: false, tree: null};
    }

    private finish() {
        //TODO: create the user-visible tree and return it.
        return new TabAST(this.fragments);
    }

    private reuseFragment(start: number) {
        for (let fI=0; fI<this.cachedFragments.length; fI++) {
            if (this.cachedFragments[fI].from > start) break;
            if (this.cachedFragments[fI].to > start) {
                if (this.cachedFragments[fI].isBlankFragment) {
                    // there might be a range overlap in the end of a 
                    // skipping fragment with the start of the subsequent, 
                    // proper fragment, so to make sure that we do not select 
                    // the skipping fragment instead of the proper fragment, we confirm
                    if (fI<this.cachedFragments.length-1 
                        && !this.cachedFragments[fI+1].isBlankFragment 
                        && this.cachedFragments[fI+1].from <= start
                    ) fI++;
                }
                this.fragments.push(this.cachedFragments[fI]);
                this.parsedPos = this.cachedFragments[fI].to;
                return true;
            }
        }
        return false;
    }
}